import { gql } from 'apollo-boost'

const DELETE_SCRAPING_TEST_CASE = gql`
  mutation deleteScrapingTestCase($id: ID!) {
    deleteScrapingTestCase(id: $id) {
      id
    }
  }
`

export default DELETE_SCRAPING_TEST_CASE
